module.exports = __webpack_public_path__ + "static/media/btg_celular_04.9c76edf6.png";